"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ScoreSystem_1 = require("../ScoreSystem");
var constants_1 = require("../../constants");
var isAthleteFemale_1 = require("../../imports/isAthleteFemale");
exports.key = constants_1.IFSC_TB;
exports.name = constants_1.scoreSystemNames[exports.key];
exports.schema = {
    top: 0,
    topAttempt: 0,
    bonus: 0,
    bonusAttempt: 0,
    display: '·',
};
var IfscTopBonus = (function (_super) {
    __extends(IfscTopBonus, _super);
    function IfscTopBonus(options) {
        return _super.call(this, {
            key: exports.key,
            name: exports.name,
            schema: exports.schema,
            round: options.round,
            routes: options.routes,
        }) || this;
    }
    IfscTopBonus.prototype.sortScoresBySummatedFunction = function (a, b) {
        var as = typeof a.summated === 'object'
            ? a.summated
            : JSON.parse(a.summated);
        var bs = typeof b.summated === 'object'
            ? b.summated
            : JSON.parse(b.summated);
        if (as.top !== bs.top) {
            return bs.top - as.top;
        }
        if (as.topAttempt !== bs.topAttempt) {
            return as.topAttempt - bs.topAttempt;
        }
        if (as.bonus !== bs.bonus) {
            return bs.bonus - as.bonus;
        }
        if (as.bonusAttempt !== bs.bonusAttempt) {
            return as.bonusAttempt - bs.bonusAttempt;
        }
        if (a.tiebreaker !== b.tiebreaker) {
            return a.tiebreaker - b.tiebreaker;
        }
        return 0;
    };
    IfscTopBonus.prototype.calculate = function (sRH) {
        var score = __assign({}, this.schema);
        var scoreString = sRH.scoreString.trim().toUpperCase().split(',');
        if (sRH.scoreString.length === 0) {
            return score;
        }
        if (scoreString.indexOf('X') >= 0) {
            score.top = 0;
            score.topAttempt = 0;
            score.bonus = 0;
            score.bonusAttempt = 0;
            score.display = '✗';
            return score;
        }
        var bonusIndex = scoreString.indexOf('B');
        if (bonusIndex >= 0) {
            score.bonus = 1;
            score.bonusAttempt = bonusIndex + 1;
        }
        var topIndex = scoreString.indexOf('T');
        if (topIndex >= 0) {
            score.top = 1;
            score.topAttempt = topIndex + 1;
            if (score.bonus === 0 ||
                score.bonusAttempt > score.topAttempt) {
                score.bonus = 1;
                score.bonusAttempt = topIndex + 1;
            }
        }
        score.display = this.generateDisplayForCalculated(score);
        return score;
    };
    IfscTopBonus.prototype.summate = function (scoreRoutes) {
        var score = scoreRoutes.reduce(function (accumulator, sR) {
            var calculated = typeof sR.calculated === 'object'
                ? sR.calculated
                : JSON.parse(sR.calculated);
            accumulator.top += calculated.top;
            accumulator.topAttempt += calculated.topAttempt;
            accumulator.bonus += calculated.bonus;
            accumulator.bonusAttempt += calculated.bonusAttempt;
            return accumulator;
        }, __assign({}, this.schema));
        score.display = this.generateDisplayForSummated(score);
        return score;
    };
    IfscTopBonus.prototype.summateTeam = function (teamScoreJoin) {
        var teamMultiplier = this.round ? this.round.teamMultiplier : 1;
        var score = teamScoreJoin.athletes.reduce(function (accumulator, aSJ) {
            var summated = typeof aSJ.score.summated === 'object'
                ? aSJ.score.summated
                : JSON.parse(aSJ.score.summated);
            var athleteMultiplier = isAthleteFemale_1.default(aSJ.athlete)
                ? teamMultiplier
                : 1;
            accumulator.top += summated.top * athleteMultiplier;
            accumulator.topAttempt += summated.topAttempt;
            accumulator.bonus += summated.bonus * athleteMultiplier;
            accumulator.bonusAttempt += summated.bonusAttempt;
            return accumulator;
        }, __assign({}, this.schema));
        score.display = this.generateDisplayForSummated(score);
        return score;
    };
    IfscTopBonus.prototype.generateDisplayForCalculated = function (score) {
        return score.top > 0
            ? "t" + score.topAttempt + " b" + score.bonusAttempt
            : score.bonus > 0
                ? score.display = "b" + score.bonusAttempt
                : '–';
    };
    IfscTopBonus.prototype.generateDisplayForSummated = function (score) {
        return score.top + "T" + score.topAttempt + " " + score.bonus + "B" + score.bonusAttempt;
    };
    return IfscTopBonus;
}(ScoreSystem_1.default));
exports.default = IfscTopBonus;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/IfscTopBonus/index.js
// module id = 851
// module chunks = 0